import { render, staticRenderFns } from "./warnBind.vue?vue&type=template&id=8cf97886&"
import script from "./warnBind.vue?vue&type=script&lang=js&"
export * from "./warnBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports